import { render } from "./Knockout.vue?vue&type=template&id=1e90d710&scoped=true"
import script from "./Knockout.vue?vue&type=script&lang=js"
export * from "./Knockout.vue?vue&type=script&lang=js"

import "./Knockout.vue?vue&type=style&index=0&id=1e90d710&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e90d710"]])

export default __exports__